import instance from '@/services/repository';

const resource = '/orders';

export default {
    getSingle(id: string) {
        return instance.get<IOrderVm>(`${resource}/${id}`);
    },
    generateDocument(payload: ICreateOrderDocumentCommand) {
        return instance.post<string>(`${resource}/generateDocument`, payload);
    },
    goodsReceived(id: string) {
        return instance.post(`${resource}/${id}/goodsReceived`);
    },
    invoiceReceived(id: string) {
        return instance.post(`${resource}/${id}/invoiceReceived`);
    },
    mail(payload: IOrderMailCommand) {
        return instance.post(`${resource}/mail`, payload);
    },
    createManual(payload: IOrderCreateCommand) {
        return instance.post<string>(`${resource}/Manual`, payload);
    },
    createFromMeasuringStates(payload: IOrderCreateFromMeasuringStatesCommand) {
        return instance.post<string>(`${resource}/Measuringstates`, payload);
    },
    update(payload: IOrderUpdateCommand) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    updateLines(payload: IOrderUpdateLinesCommand) {
        return instance.put(`${resource}/${payload.id}/Lines`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    download(id: string) {
        return instance
            .get<Blob>(`${resource}/${id}/document`, { responseType: 'blob' });
    },
    getDocumentUrl(id: string) {
        return instance
            .get<string>(`${resource}/${id}/documentUrl`);
    },
    getTemplates() {
        return instance
            .get<any[]>(`${resource}/templates`);
    },
    /*mail(payload: any) {
        return instance.post(`${resource}/Mail`, payload);
    },*/
};
